// extracted by mini-css-extract-plugin
export default {"meaning":"SatyugMeaning_meaning__at-iy"};